/**
 * Tells the breadcrumb which URLs the router can actually render.
 *
 * The breadcrumb builds a trail from the path segments, so on /admin/users it
 * offers an "Admin" crumb for /admin — a path no <Route> serves, which lands
 * the operator on the 404 page. The router registers its own route tree here so
 * a crumb is only a link when going there works.
 */
import type { ReactNode } from 'react';
import { createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

let routes: readonly RouteObject[] = [];

export function registerRouteTree(children: ReactNode): void {
  routes = createRoutesFromChildren(children);
}

export function isNavigablePath(pathname: string): boolean {
  if (routes.length === 0) return false;
  const matches = matchRoutes(routes as RouteObject[], pathname);
  if (!matches || matches.length === 0) return false;
  // The catch-all renders the 404 screen, so matching it means "not navigable".
  return !matches.some((m) => m.route.path === '*');
}
